"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plugin = void 0;
var tslib_1 = require("tslib");
var blocks_repeater_1 = tslib_1.__importDefault(require("./blocks-repeater"));
var block_container_1 = tslib_1.__importDefault(require("./block-container"));
var keys_1 = require("./keys");
var consola_1 = tslib_1.__importDefault(require("consola"));
exports.plugin = {
    install: function (app, options) {
        var _a, _b, _c, _d, _e, _f;
        if (options.blockComponents) {
            for (var _i = 0, _g = Object.entries(options.blockComponents); _i < _g.length; _i++) {
                var _h = _g[_i], key = _h[0], value = _h[1];
                var fullKey = "block-".concat(key.replace(/.([A-Z])/g, function (m) { return "".concat(m[0], "-").concat(m[1]); })).toLowerCase();
                app.component(fullKey, value);
            }
        }
        if (typeof window === 'object' && ((_c = (_b = (_a = window.__DRAPEJS_STATE__) === null || _a === void 0 ? void 0 : _a.cache) === null || _b === void 0 ? void 0 : _b.__litium_options) === null || _c === void 0 ? void 0 : _c.baseUrl)) {
            consola_1.default.trace('drapeJS-litium: Found litium endpoint from embedded SSR state, using that instead of supplied endpoint');
            options.baseUrl = (_f = (_e = (_d = window.__DRAPEJS_STATE__) === null || _d === void 0 ? void 0 : _d.cache) === null || _e === void 0 ? void 0 : _e.__litium_options) === null || _f === void 0 ? void 0 : _f.baseUrl;
        }
        app.cache.setItem('__litium_options', {
            baseUrl: options.baseUrl,
            additionalHeaders: options.additionalHeaders
        });
        app.provide(keys_1.litiumBaseUrlKey, options.baseUrl);
        app.provide(keys_1.toLitiumMediaUrlKey, toLitiumMediaUrl);
        app.mixin({
            methods: {
                $toLitiumMediaUrl: function (id, dimensions, bracket) {
                    return toLitiumMediaUrl(id, dimensions, bracket);
                },
            },
        });
        if (!options.disableBlocks) {
            app.component('blocks-repeater', blocks_repeater_1.default);
            app.component('block-container', block_container_1.default);
        }
        function toLitiumMediaUrl(id, dimensions, bracket) {
            if (bracket === void 0) { bracket = 50; }
            var qs = [];
            if (dimensions === null || dimensions === void 0 ? void 0 : dimensions.maxWidth) {
                if (typeof window !== 'undefined' && window.devicePixelRatio) {
                    dimensions.maxWidth = dimensions.maxWidth && Math.ceil(dimensions.maxWidth * window.devicePixelRatio);
                }
                if (bracket) {
                    dimensions.maxWidth = (performIntegerDivision(dimensions.maxWidth, bracket) + 1) * bracket;
                }
                qs.push("maxWidth=".concat(dimensions.maxWidth));
            }
            if (dimensions === null || dimensions === void 0 ? void 0 : dimensions.maxHeight) {
                if (typeof window !== 'undefined' && window.devicePixelRatio) {
                    dimensions.maxHeight = dimensions.maxHeight && Math.ceil(dimensions.maxHeight * window.devicePixelRatio);
                }
                if (bracket) {
                    dimensions.maxHeight = (performIntegerDivision(dimensions.maxHeight, bracket) + 1) * bracket;
                }
                qs.push("maxHeight=".concat(dimensions.maxHeight));
            }
            if (dimensions === null || dimensions === void 0 ? void 0 : dimensions.fillArea) {
                var focalPoint = dimensions.fillArea.focalPoint ? "_".concat(dimensions.fillArea.focalPoint.left, "_").concat(dimensions.fillArea.focalPoint.top) : '';
                qs.push("fillArea=".concat(dimensions.fillArea.width, "x").concat(dimensions.fillArea.height).concat(focalPoint));
            }
            var imageUrl = "".concat(options.baseUrl, "/api/media/image/").concat(id);
            if (qs.length) {
                imageUrl += "?".concat(qs.join('&'));
            }
            return imageUrl;
        }
        function performIntegerDivision(a, b) {
            return ~~(a / b);
        }
    },
};
//# sourceMappingURL=plugin.js.map